<template>
    <div class="card marginL201 clearfix" v-loading="!isSuccess">
        <div class="login-title h50">
            <span></span>
            我的名片
        </div>
        <div class="card-wrap fl" v-if="isSuccess">
            <div>
                <h2 class="card-item-title">工作信息</h2>
                <div class="clearfix marginB15">
                    <label class="w78 fl h30 fontSize14 card-label">执业机构 ：</label>
                    <el-input size="small" class="form-input w220 h24" readonly :value="docInfo.docHosName"></el-input>
                    <!--<el-select v-model="organization" placeholder="请选择您的执业医院" size="small" class="form-input w220 h24">
                        <el-option label="张医生" value="shanghai"/>
                        <el-option label="王医生" value="beijing"/>
                    </el-select>-->
                    <label class="w78 fl h30 fontSize14 marginL40 card-label">所属科室 ：</label>
                    <el-input size="small" class="form-input w220 h24" readonly :value="docInfo.docDeptName"></el-input>
                    <!--<el-select v-model="selectDoctor" placeholder="请选择您的执业科室" size="small" class="form-input w220 h24">
                        <el-option label="张医生" value="shanghai"/>
                        <el-option label="王医生" value="beijing"/>
                    </el-select>-->
                </div>
                <div class="clearfix">
                    <label class="w78 fl h30 fontSize14 card-label">职称 ：</label>
                    <el-input size="small" class="form-input w220 h24" readonly :value="docInfo.docTitle"></el-input>
                    <!--<el-select v-model="selectDoctor" placeholder="请选择您的职称" size="small" class="form-input w220 h24">
                        <el-option label="张医生" value="shanghai"/>
                        <el-option label="王医生" value="beijing"/>
                    </el-select>-->
                </div>
            </div>
            <!--<div>-->
                <!--<h2 class="card-item-title">公告</h2>-->
                <!--<el-input type="textarea" class="card-textarea h60  fontSize12" v-model="docNotice"/>-->
            <!--</div>-->
            <div>
                <h2 class="card-item-title">擅长领域</h2>
                <el-input type="textarea" class="card-textarea h60 fontSize12" v-model="docSkill"/>
            </div>
            <div>
                <h2 class="card-item-title">个人详细介绍</h2>
                <el-input type="textarea" class="card-textarea h99 fontSize12" v-model="docResume"/>
            </div>
            <div class="btn-wrap marginT45 marginB30">
                <el-button type="primary" class="btn h36 w140" @click="saveInfo" :loading="isSubmit">
                    保存
                </el-button>
                <el-button type="primary" class=" btn h36 w140" @click="linkToPersonalPage">
                    个人主页
                </el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import axiosUtil from "../../utils/AxiosUtils.js"
    import { Message, Loading } from "element-ui";
    import html2Escape from "../../utils/Html2Escape"
    import Vue from "vue";
    Vue.use(Loading);
    export default{
        data: function(){
            return{
                isSuccess: false,//是否加载成功
                isSubmit: false,//是否提交成功
                docInfo: {},//医生详情
                docSkill: "",
                docResume: "",
                docNotice: "",
            }
        },
        created: function () {
            this.getConsultDetail();
        },
        methods:{
            getConsultDetail: function(){//根据consultId获取会诊单数据
                this.isSuccess = false;
                let _this = this;
                let options = {
                    docId: JSON.parse(sessionStorage.getItem("loginInfo")).docId,
                    token: localStorage.getItem("token"),
                    Service: "nethos.doc.detail"
                };
                axiosUtil(options, function(data){
                    _this.isSuccess = true;
                    _this.docInfo = data.obj;
                    _this.docResume = data.obj.docResume;
                    _this.docSkill = data.obj.docSkill;
                    _this.docNotice = data.obj.docNotice;
                }, function () {
                    _this.isSuccess = true;
                });
            },
            saveInfo: function () {//保存修改的信息
                this.isSubmit = true;
                let _this = this;
                let options = {
                    docId: JSON.parse(sessionStorage.getItem("loginInfo")).docId,
                    docResume: html2Escape(_this.docResume),
                    docSkill: html2Escape(_this.docSkill),
                    docNotice: html2Escape(_this.docNotice),
                    token: localStorage.getItem("token"),
                    Service: "nethos.doc.info.modify"
                };
                axiosUtil(options, function(data){
                    _this.isSubmit = false;
                    let userInfo = JSON.parse(sessionStorage.getItem("loginInfo"));
                    userInfo.docResume = _this.docResume;
                    userInfo.docSkill = _this.docSkill;
                    localStorage.removeItem("userInfo");
                    localStorage.setItem("userInfo", JSON.stringify(userInfo));
                    Message({
                       showClose: true,
                       message: "保存成功！",
                       type: "success"
                    });
                }, function () {
                    _this.isSubmit = false;
                });
            },
            linkToPersonalPage: function(){// 跳转到个人主页
                this.$router.push("/personalPage");
            }
        }
    }
</script>
